module.exports = __webpack_public_path__ + "img/result-contact-btn.491b8f16.png";